angular
  .module('contabilidad.reportesexternos')
  .service('ReportesexternosInventariosCsv', ReportesexternosInventariosCsvService)

function ReportesexternosInventariosCsvService ($http) {
  this.get = get

  function get (fechaInicial, fechaFinal, sucursales) {
    return $http.get('/api/contabilidad/reportes_externos/inventario/csv', {
      params: {
        fecha_incial: fechaInicial,
        fecha_final: fechaFinal,
        sucursales: sucursales,
      },
      download: true,
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/services/Inventario/Csv.js